// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CloseButton__button-container-e2df93:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.CloseButton__button-container-e2df93:active {
  background-color: rgba(255, 255, 255, 0.2);
}

.CloseButton__button-icon-d4f97d {
  fill: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/CloseButton/CloseButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".button-container:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.button-container:active {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.button-icon {\n  fill: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-container": `CloseButton__button-container-e2df93`,
	"buttonContainer": `CloseButton__button-container-e2df93`,
	"button-icon": `CloseButton__button-icon-d4f97d`,
	"buttonIcon": `CloseButton__button-icon-d4f97d`
};
module.exports = ___CSS_LOADER_EXPORT___;
